export default __webpack_public_path__ + "static/media/hht2_ep_13.3cf86d47.png";